import { render, staticRenderFns } from "./TestTutorialsPartTwo.vue?vue&type=template&id=74780774&scoped=true&"
import script from "./TestTutorialsPartTwo.vue?vue&type=script&lang=js&"
export * from "./TestTutorialsPartTwo.vue?vue&type=script&lang=js&"
import style0 from "./TestTutorialsPartTwo.vue?vue&type=style&index=0&id=74780774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74780774",
  null
  
)

export default component.exports